/**
 * Enum for search bar result category types.
 */
export default class SearchBarResultCategory {
  /**
   * Gets the All Results category type.
   * @returns {SearchBarResultCategory} The All Results category type.
   */
  static get AllResults() {
    return this.getInstance('allResults', '1');
  }

  /**
   * Gets the Location result category type.
   * @returns {SearchBarResultCategory} The Location result category type.
   */
  static get Location() {
    return this.getInstance('locations', '2');
  }


  /**
   * Gets the Community result category type.
   * @returns {SearchBarResultCategory} The Community result category type.
   */
  static get Community() {
    return this.getInstance('communities', '3');
  }

  /**
   * Gets the Builder result category type.
   * @returns {SearchBarResultCategory} The Builder result category type.
   */
  static get Builder() {
    return this.getInstance('builders', '4');
  }

  /**
   * Gets the Article result category type.
   * @returns {SearchBarResultCategory} The Article result category type.
   */
  static get Article() {
    return this.getInstance('articles', '5');
  }

  /**
   * Gets an instance of SearchBarResultCategory based on the provided key.
   * If an instance with the same key already exists, it returns that instance.
   * Otherwise, it creates a new instance and stores it for future use.
   */
  static getInstance(key, id) {
    if (!this.instances[key]) {
      this.instances[key] = new SearchBarResultCategory(key, id);
    }
    return this.instances[key];
  }

  constructor(name, id) {
    this.name = name;
    this.id = id;
  }

  /**
   * Converts the location type to a string representation.
   * @returns {string} The string representation of the location type.
   */
  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(SearchBarResultCategory, 'instances', { value: {} });